<template>
    <div>
        <div ref="results">
            <div class="alert" :class="{ 'alert-danger' : !passed, 'alert-success': passed }">
                {{ passed ? 'This test has passed' : 'This test has failed. See details below' }}
            </div>
            <table class="table">
                <thead><tr><th>Question</th><th>Result</th></tr></thead>
                <tbody>
                    <template v-for="(items, category) in results" >
                        <tr :key="category">
                            <td colspan="2" style="font-weight: bold;" v-html="category"></td>
                        </tr>
                        <tr v-for="(item, index) in items" :key="`${category}_${index}`">
                            <td>{{ item.question }}</td>
                            <td>{{ item.result }}</td>
                        </tr>
                    </template>
                </tbody>
            </table>
        </div>
        <div class="row ml-1 mt-2">
            <span style="font-weight: bold;">Please print and retain this page for your records</span>
        </div>
        <div class="row ml-1 mt-3">
            <input type="button" class="btn btn-success" value="Download Results" @click.prevent="downloadResults" />
            <div class="ml-3"><input type="button" class="btn btn-primary" value="Take Again" @click.prevent="takeAgain" /></div>
        </div>
    </div>
</template>

<script>
    import html2pdf from 'html2pdf.js'

    async function saveToFile(filename, element) {
        var options = {
            margin: 1,
            filename,
            jsPDF: { unit: 'in', format: 'letter', orientation: 'portrait' }
        }

        await html2pdf().set(options).from(element).save();
    }

    export default {
        props: {
            questions: { type: Array, required: true },
            employerId: { type: String, required: true }
        },
        computed: {
            passed() {
                return this.questions.every(q => q.passed === true);
            },
            results() {
                let questions = this.questions;
                let results = questions.filter(q => q.result && q.result.length)
                    .map(q => [...q.result].map(r => { r.category = q.category; return r; }))
                    .reduce((a, c) => a.concat(c), []);

                return _.groupBy(results, 'category');
            }
        },
        methods: {
            async downloadResults() {
                var answers = this.questions[0].answers;
                answers.passed = this.passed;
                answers = {..._.pickBy(answers, value => value !== null && value !== undefined) };
                
                await saveToFile('pop-non-discrimination.pdf', this.$refs.results);
                await romeApi.post(`/employer/${this.employerId}/non-discrimination/pop`, answers);
            },
            takeAgain() {
                this.$emit('restart');
            }
        }
    }
</script>

<style lang="scss" scoped>
</style>


// WEBPACK FOOTER //
// src/shared/Nondiscrimination/POP/Results.vue